import keyBy from 'lodash/keyBy';
import { Table$ } from '../Table$';

type Input = {
    product: Table$.Product;
    productPrice: number;
    modGroupIds?: Record<string, number[]>;
};

export function getProductPrice(input: Input) {
    const { product, productPrice, modGroupIds = {} } = input;

    let priceCombined = productPrice || 0;

    const modifierGroupModifierById = keyBy(
        product.modifierGroups.flatMap((group) => group.modifierGroupItems),
        (item) => item.id,
    );

    Object.keys(modGroupIds).forEach((id) => {
        const ids = modGroupIds[id] || [];

        if (ids.length > 0) {
            ids.forEach((id) => {
                const price =
                    modifierGroupModifierById[id].price ?? (modifierGroupModifierById[id].product?.price || 0);

                priceCombined += price;
            });
        }
    });

    return priceCombined;
}
